import { DresonRuleResolvedEvent } from "../../types/FilterTypes";
import { replaceNode } from "./Utils";

export default class LoadSeoBottomLinks {
  static onLoadSeoBottomLinks(data: DresonRuleResolvedEvent): void {
    const bottomLinksNode: HTMLElement | null =
      document.getElementById("reptile-bottom-links") || document.getElementById("san_bottomLinks");
    if (!bottomLinksNode) {
      return;
    }

    const { rule } = bottomLinksNode.dataset;
    if (rule === data.rule) {
      return;
    }

    fetch(LoadSeoBottomLinks.uri(data.rule))
      .then(LoadSeoBottomLinks.extractResponseText)
      .then((html: string) => LoadSeoBottomLinks.replaceBottomLinks(bottomLinksNode, data.rule, html))
      .catch((e: Error) => {
        console.warn(`Filter reload AJAX GET against ${LoadSeoBottomLinks.uri(data.rule)} failed: ${e.message}`);
      });
  }

  private static extractResponseText(xhr: Response) {
    if (xhr.status !== 200 && xhr.status !== 204) {
      throw Error(`Failed to retrieve bottom links: ${xhr.status} ${xhr.statusText}`);
    }
    return xhr.text();
  }

  /**
 *
 *
 *
 *
 */
  private static replaceBottomLinks(bottomLinksNode: HTMLElement, nodeRule: string, newHtml: string) {
    replaceNode(bottomLinksNode, nodeRule, newHtml);
  }

  private static uri(ruleString: string) {
    return `/scp-bob/page/${encodeURIComponent(ruleString)}/bottom-links.html`;
  }
}
